/** Application locales. */
export const locales: string[] = ['cs', 'de', 'es', 'fr', 'it', 'sv', 'zh'];
